import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable, throwError, from } from 'rxjs'; import { switchMap, catchError } from 'rxjs/operators';
import { AuthHeaderService } from 'src/app/services/auth-header.service';
import { SanctumService } from 'src/app/services/sanctum.service';
import { RevalidatedHttpService, RevalidatedResource } from 'src/app/core/http-cache/revalidated-http.service';
export interface Widget {
  id: number;
  uid: string;
  type: number;
  name: string;
  smart: number | null;
  store_id: number;
  tags: string;
  title: string;
  limit: number | null;
  assets_count: number | null;
  template: string | null;
  url_display: string | null;
  created_at: string;
  updated_at: string;
  feed_type: string;
}
export interface IStoreData {
  id: number;
  owned_by_company_id?: number;
  owned_by_user_id: number;
  store_name: string;
  store_description?: string;
  store_link_subdomain: string;
  store_link_domain?: string;
  store_zip_code?: string;
  store_street?: string;
  store_number?: string;
  store_district?: string;
  store_city?: string;
  store_uf?: string;
  store_complement?: string;
  support_email?: string;
  support_phone_number?: string;
  support_whatsapp?: string;
  support_whatsapp_status: number;
  zipcode?: string;
  metadata_object_id?: string;
  show_address: number;
  maintenence_status: number;
  status: number;
  created_at: string;
  updated_at: string;
  channel_id: number;
  public_token: string;
  store_logo?: string;
}

export interface WidgetDetailsResponse {
  id: number;
  uid: string;
  published: number;
  type: number;
  smart: number;
  store_id: number;
  title: string;
  feed_type: string;
  slick_filter: string;
  max_limit: number | null;
  tags: string;
  template: string;
  url_display: string;
  assets: {
    id: number;
    position: number | null; // Adicionei o campo 'position', que também faz parte de cada asset
  }[];
  style: {
    popup: {
      position?: string;
      highlight?: string;
      shape?: string;
      background_color?: string;
    },
    iframe: {
      selectedResolution?: {
        width: number;
        height: number;
      };
    },
    inline: {
      selectedResolution?: {
        width: number;
        height: number;
      };
      showDescription?: boolean;
      showProducts?: boolean;
    },
    carousel: {
      position?: string;
      highlight?: string;
      background_color?: string;
      font_color?: string;
      showProducts?: boolean;
    },
    stories: {
      position?: string;
      highlight?: string;
      background_color?: string;
      font_color?: string;
      showProducts?: boolean;
    }
  };
  widget_rule: {
    device_display: {
      mobile_display: boolean;
      desktop_display: boolean;
    };
    url_display: {
      contain_rule: string;
      equal_rule: string;
    };
  };
  created_at: string;
  updated_at: string;
}
export interface AssetsResponse {
  assets: {
    items: {
      schedule: {
        date_from: string;
        date_to: string | null;
      };
      media: {
        type: string;
        src: string;
        thumbnail: string | null;
        duration: number;
        aspect_ratio: string;
        pin: number;
        status: number;
      };
      content: {
        id: number;
        uid: string;
        title: string;
        description: string;
      };
    }[];
  }[];
  totalAssets?: number;
  page?: number;
  limit?: number | string;
  nextPage?: number | null;
}
@Injectable({
  providedIn: 'root'
})
export class WidgetsService {
  // Http Headers
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${this.getAccessToken()}`
    }),
  };
  baseurl = `${environment.apiBaseUrl}/api`; // Base_url
  baseurl2 = `${environment.apiBaseUrl}/`; // Base_url
  constructor(
    private httpClient: HttpClient,
    private sanctum: SanctumService,
    private authHeaderService: AuthHeaderService,
    private revalidatedHttp: RevalidatedHttpService
  ) {
    // this.dadosUsuarioLogado();
    if (environment.production) {
      this.baseurl = environment.serverUrl;
    } else {
      this.baseurl = environment.paymentGenetatorLinkURL;
    }
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${this.getAccessToken()}`
      }),
    };
  }

  getWidgets(): Observable<Widget[]> {
    const storeId = localStorage.getItem("ss_SelectedStoreId") || '';

    const baseUrl = `${environment.apiBaseUrl}/api`;

    const url = `${baseUrl}/admin/store/${storeId}/videoshopping/widget`;

    return from(this.authHeaderService.getHttpOptions()).pipe(
      switchMap(httpOptions =>
        this.httpClient.get<Widget[]>(url, httpOptions)
      )
    );
  }

  // Cache-first com ETag (ver src/app/core/http-cache).
  getWidgetsRevalidated(): RevalidatedResource<Widget[]> {
    const storeId = localStorage.getItem("ss_SelectedStoreId") || '';

    const baseUrl = `${environment.apiBaseUrl}/api`;

    const url = `${baseUrl}/admin/store/${storeId}/videoshopping/widget`;
    const cacheKey = `widgets:store:${storeId}`;

    return this.revalidatedHttp.getSignal<Widget[]>(
      cacheKey,
      url,
      this.authHeaderService.getHttpOptions()
    );
  }

  getPrintEvents(): Observable<Widget[]> {
    const storeId = localStorage.getItem("ss_SelectedStoreId") || '';

    const baseUrl = `${environment.apiBaseUrl}/api`;

    const url = `${baseUrl}/store/${storeId}/analytics/print_events`;

    return from(this.authHeaderService.getHttpOptions()).pipe(
      switchMap(httpOptions =>
        this.httpClient.get<Widget[]>(url, httpOptions)
      )
    );
  }

  // Cache-first com ETag.
  getPrintEventsRevalidated(): RevalidatedResource<Widget[]> {
    const storeId = localStorage.getItem("ss_SelectedStoreId") || '';

    const baseUrl = `${environment.apiBaseUrl}/api`;

    const url = `${baseUrl}/store/${storeId}/analytics/print_events`;
    const cacheKey = `print_events:store:${storeId}`;

    return this.revalidatedHttp.getSignal<Widget[]>(
      cacheKey,
      url,
      this.authHeaderService.getHttpOptions()
    );
  }











  deleteWidgets(widget_id: number): Observable<Widget[]> {
    const storeId = localStorage.getItem("ss_SelectedStoreId") || '';

    const baseUrl = `${environment.apiBaseUrl}/api`;

    const url = `${baseUrl}/admin/store/${storeId}/videoshopping/widget/${widget_id}`;

    return from(this.sanctum.initSanctum()).pipe(
      switchMap(() =>
        from(this.authHeaderService.getHttpOptions()).pipe(
          switchMap(httpOptions =>
            this.httpClient.delete<Widget[]>(url, httpOptions)
          )
        )
      )
    );
  }




  getAssets(filter?: string, page: number = 1, limit: number = 15, widgetUid?: string): Observable<AssetsResponse> {
    const id_loja = localStorage.getItem("ss_SelectedStoreId") || '';
    const baseUrl = `${environment.apiBaseUrl}/api`;
    
    let params = new HttpParams()
      .set('limit', String(limit))
      .set('page', String(page));

    if (filter) {
      params = params.set('filter', filter);
    }

    if (widgetUid) {
      params = params.set('widget_uid', widgetUid);
    }

    const url = `${baseUrl}/admin/store/${id_loja}/videoshopping/asset`;

    return from(this.authHeaderService.getHttpOptions()).pipe(
      switchMap(httpOptions =>
        this.httpClient.get<AssetsResponse>(url, { ...httpOptions, params })
      ),
      catchError(error => throwError(() => error))
    );
  }

  listarAssetsWidget(
    widget_id: number | null,
    page: number | null = 1,
    limit: number | null = 1
  ): Observable<AssetsResponse> {
    const id_loja = localStorage.getItem("ss_SelectedStoreId") || '163';
    const pageParam = page ?? 1;

    const baseUrl = `${environment.apiBaseUrl}/api`;

    const url = `${baseUrl}/admin/store/${id_loja}/videoshopping/widget/${widget_id}/assets?page=${pageParam}&limit=${limit}`;

    return from(this.authHeaderService.getHttpOptions()).pipe(
      switchMap(httpOptions =>
        this.httpClient.get<AssetsResponse>(url, httpOptions)
      )
    );
  }

  detailWidget(uid: string | undefined = undefined): Observable<WidgetDetailsResponse> {
    let id_loja = localStorage.getItem("ss_SelectedStoreId") || '';

    if (!id_loja) {
      const storeInfo = localStorage.getItem("store");
      if (storeInfo) {
        try {
          const storeData = JSON.parse(storeInfo);
          id_loja = storeData.SelectedStoreId || '';
        } catch (error) {
          console.error("Erro ao tentar acessar 'SelectedStoreId' do objeto 'store':", error);
          id_loja = '';
        }
      }
    }

    const baseUrl = `${environment.apiBaseUrl}/api`;

    const url = `${baseUrl}/admin/store/${id_loja}/videoshopping/widget/detail/${uid}`;

    return from(this.authHeaderService.getHttpOptions()).pipe(
      switchMap(httpOptions =>
        this.httpClient.get<WidgetDetailsResponse>(url, httpOptions)
      )
    );
  }

  detailWidgetPublic(uid: string | undefined = undefined): Observable<WidgetDetailsResponse> {

    let id_loja = localStorage.getItem("ss_SelectedStoreId") || '';
    // Se não encontrar, tenta pegar o SelectedStoreId dentro do objeto 'store' no localStorage
    if (!id_loja) {
      const storeInfo = localStorage.getItem("store");

      if (storeInfo) {
        try {
          const storeData = JSON.parse(storeInfo); // Converte o JSON de volta para objeto
          id_loja = storeData.SelectedStoreId || ''; // Acessa o SelectedStoreId dentro do objeto 'store'
        } catch (error) {
          console.error("Erro ao tentar acessar 'SelectedStoreId' do objeto 'store':", error);
          id_loja = ''; // Em caso de erro no parsing, define como vazio
        }
      }
    }

    return this.httpClient.get<WidgetDetailsResponse>(`${environment.apiBaseUrl}/api/admin/store/${id_loja}/videoshopping/widget/detail/${uid}/public`, this.httpOptions);
  }
  createWidget(widgetData: any): Observable<WidgetDetailsResponse> {
    const id_loja = localStorage.getItem("ss_SelectedStoreId") || '';

    const baseUrl = `${environment.apiBaseUrl}/api`;

    const url = `${baseUrl}/admin/store/${id_loja}/videoshopping/widget/create`;

    return from(this.sanctum.initSanctum()).pipe(
      switchMap(() =>
        from(this.authHeaderService.getHttpOptions()).pipe(
          switchMap(httpOptions =>
            this.httpClient.post<WidgetDetailsResponse>(url, widgetData, httpOptions)
          )
        )
      )
    );
  }


  filterWidgetsByPageType(
    pageType: string | null,
    template: string,
    currentUid?: string
  ): Observable<{ uid: string, url_display: string }[]> {
    const id_loja = localStorage.getItem("ss_SelectedStoreId") || '';

    const baseUrl = `${environment.apiBaseUrl}/api`;

    const query = [
      `page_type=${encodeURIComponent(pageType || '')}`,
      `template=${encodeURIComponent(template)}`,
      `current_uid=${encodeURIComponent(currentUid || '')}`
    ].join('&');

    const apiUrl = `${baseUrl}/admin/store/${id_loja}/filterWidgets?${query}`;

    return from(this.authHeaderService.getHttpOptions()).pipe(
      switchMap(httpOptions =>
        this.httpClient.get<{ uid: string, url_display: string }[]>(apiUrl, httpOptions)
      )
    );
  }



  editWidget(widgetData: any, id: number): Observable<AssetsResponse> {
    const id_loja = localStorage.getItem("ss_SelectedStoreId") || '';
    const urlBase = `${environment.apiBaseUrl}/api`;
    const url = `${urlBase}/admin/store/${id_loja}/videoshopping/widget/${id}`;

    return from(this.sanctum.initSanctum()).pipe(
      switchMap(() =>
        from(this.authHeaderService.getHttpOptions()).pipe(
          switchMap(httpOptions =>
            this.httpClient.patch<AssetsResponse>(url, widgetData, httpOptions)
          )
        )
      )
    );
  }



  addWidget(widgetData: any, uid: string | undefined): Observable<AssetsResponse> {
    const id_loja = localStorage.getItem("ss_SelectedStoreId") || '';
    const urlBase = `${environment.apiBaseUrl}/api`;
    const url = `${urlBase}/admin/store/${id_loja}/videoshopping/widget_asset/${uid}`;

    return from(this.sanctum.initSanctum()).pipe(
      switchMap(() =>
        from(this.authHeaderService.getHttpOptions()).pipe(
          switchMap(httpOptions =>
            this.httpClient.post<AssetsResponse>(url, widgetData, httpOptions)
          )
        )
      )
    );
  }


  subWidget(widgetData: any, uid: string | undefined): Observable<AssetsResponse> {
    const id_loja = localStorage.getItem("ss_SelectedStoreId") || '';
    const urlBase = `${environment.apiBaseUrl}/api`;

    const url = `${urlBase}/admin/store/${id_loja}/videoshopping/widget_asset/${uid}`;

    return from(this.sanctum.initSanctum()).pipe(
      switchMap(() =>
        from(this.authHeaderService.getHttpOptions()).pipe(
          switchMap(httpOptions =>
            this.httpClient.patch<AssetsResponse>(url, widgetData, httpOptions)
          )
        )
      )
    );
  }

  getAccessToken(): string {
    return localStorage.getItem('access_token') || '';
  }

}
